// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__bFxdO","rotation":"Loader_rotation__peDd8","loaderMessage":"Loader_loaderMessage__KOBwV","loaderContainer":"Loader_loaderContainer__9FH+B"};